/* istanbul ignore file */
import { PropertyBoxProps } from '../components/claimMyListing/typesDefinition'

export const getPropertyField = (
  property: PropertyBoxProps['property'],
  path: keyof PropertyBoxProps['property']
) => {
  return property[path] ? property[path] : '...'
}

// Avoid special characters in query params to prevent XSS attacks
// No HTML tags or scripts, cleaned up whitespace, and limit length to 200 characters
export const sanitizeQueryParam = (value: string) =>
  value.replace(/[<>]/g, '').trim().slice(0, 200)
